/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Player_Completed_Awaiting_FinalsInputs */



/**
* | output |
* | --- |
* | "You've played all your rounds — sit tight, you're eligible for the finals." |
*
* @param {Player_Completed_Awaiting_FinalsInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const player_completed_awaiting_finals = /** @type {((inputs?: Player_Completed_Awaiting_FinalsInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Player_Completed_Awaiting_FinalsInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Vous avez joué toutes vos rondes — patientez, vous êtes éligible pour la finale.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Has jugado todas tus rondas — espera, eres elegible para las finales.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Você já jogou todas as suas rodadas — aguarde, você é elegível para as finais.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Hai giocato tutti i tuoi round — attendi, sei idoneo alle finali.")
	return /** @type {LocalizedString} */ ("You've played all your rounds — sit tight, you're eligible for the finals.")
});